import { Reports } from '@features/client/models/reports.model';
import {
  clearCapacityMonitoringData,
  clearCapacityMonitoringPdfTemplateData,
  clearOverviewData,
  clearResearchDepartments,
  deleteReportSuccess,
  getCapacityMonitoring,
  getCapacityMonitoringFailure,
  getCapacityMonitoringPdfTemplateSuccess,
  getCapacityMonitoringSuccess,
  getCostAvoidanceSuccess,
  getOverview,
  getOverviewFailure,
  getOverviewSuccess,
  getResearchDepartmentsSuccess,
  getResearchDetailsSuccess,
  getResearchReportsSuccess,
  getSavedReportsSuccess,
  getWorkspaceOptimizationSuccess,
  setResearchId,
  updateReportSuccess
} from '@features/client/store/client.actions';
import { ClientState } from '@features/client/store/client.state';
import { Action, createReducer, on } from '@ngrx/store';

export function clientReducer(state: ClientState | undefined, action: Action): ClientState {
  return reducer(state, action);
}

const initialState: ClientState = {
  overview: null,
  capacityMonitoring: null,
  capacityMonitoringPdfTemplate: null,
  optimization: null,
  costAvoidance: null,
  departments: [],
  initialDashboardLoading: false,
  loadingDashboardContent: false,
  isDashboardContentAlreadyLoaded: false,
  reports: null
};

const reducer = createReducer(
  initialState,
  on(getOverview, (state) => ({
    ...state,
    isDashboardContentAlreadyLoaded: state.overview !== null,
    initialDashboardLoading: state.overview === null,
    loadingDashboardContent: state.overview !== null
  })),
  on(getOverviewSuccess, (state, action) => ({
    ...state,
    overview: action.overview,
    isDashboardContentAlreadyLoaded: state.isDashboardContentAlreadyLoaded
      ? true
      : action.overview !== null
      ? true
      : false,
    initialDashboardLoading: false,
    loadingDashboardContent: false
  })),
  on(getOverviewFailure, (state) => ({
    ...state,
    initialDashboardLoading: false,
    loadingDashboardContent: false
  })),
  on(getCapacityMonitoring, (state) => ({
    ...state,
    isDashboardContentAlreadyLoaded: state.capacityMonitoring !== null,
    initialDashboardLoading: state.capacityMonitoring === null,
    loadingDashboardContent: state.capacityMonitoring !== null
  })),
  on(getCapacityMonitoringSuccess, (state, action) => ({
    ...state,
    capacityMonitoring: action.capacityMonitoring,
    isDashboardContentAlreadyLoaded: state.isDashboardContentAlreadyLoaded
      ? true
      : action.capacityMonitoring !== null
      ? true
      : false,
    initialDashboardLoading: false,
    loadingDashboardContent: false
  })),
  on(getCapacityMonitoringPdfTemplateSuccess, (state, action) => ({
    ...state,
    capacityMonitoringPdfTemplate: action.capacityMonitoring
  })),
  on(clearCapacityMonitoringPdfTemplateData, (state) => ({
    ...state,
    capacityMonitoringPdfTemplate: null
  })),
  on(getCapacityMonitoringFailure, (state) => ({
    ...state,
    initialDashboardLoading: false,
    loadingDashboardContent: false
  })),
  on(getResearchDepartmentsSuccess, (state, action) => ({
    ...state,
    departments: action.departments
  })),
  on(clearResearchDepartments, (state) => ({
    ...state,
    departments: []
  })),
  on(setResearchId, (state, action) => ({
    ...state,
    researchId: action.researchId
  })),
  on(clearOverviewData, (state) => ({
    ...state,
    overview: null
  })),
  on(clearCapacityMonitoringData, (state) => ({
    ...state,
    capacityMonitoring: null
  })),
  on(getSavedReportsSuccess, (state, action) => ({
    ...state,
    reports: { ...(state.reports as Reports), savedReports: action.reports }
  })),
  on(getResearchReportsSuccess, (state, action) => ({
    ...state,
    reports: {
      ...(state.reports as Reports),
      researchReports: action.researchReports
    }
  })),
  on(getCostAvoidanceSuccess, (state, action) => ({
    ...state,
    costAvoidance: action.costAvoidance
  })),
  on(deleteReportSuccess, (state, action) => ({
    ...state,
    reports: {
      ...(state.reports as Reports),
      savedReports: (state.reports as Reports).savedReports.filter((report) => report.id !== action.reportId)
    }
  })),
  on(getWorkspaceOptimizationSuccess, (state, action) => ({
    ...state,
    optimization: action.optimization
  })),
  on(updateReportSuccess, (state, action) => {
    if (!state.reports) return state;
    return {
      ...state,
      reports: {
        ...state.reports,
        savedReports: (state.reports as Reports).savedReports.map((report) => {
          if (report.id === action.report.id) {
            return action.report;
          }
          return report;
        })
      }
    };
  }),
  on(getResearchDetailsSuccess, (state, action) => {
    return {
      ...state,
      researchDetails: action.researchDetails
    };
  })
);
